import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import AppConfig from '../../appConfig';

/**
 * AuthGuard - protects child routes when Auth0 is enabled.
 * When Auth0 is not configured (dev mode), renders children directly.
 * When Auth0 is configured, redirects to Auth0 login if not authenticated.
 */
const AuthGuard = ({ children }) => {
    if (!AppConfig.auth0.useAuth0) {
        return <>{children}</>;
    }

    return <Auth0Guard>{children}</Auth0Guard>;
};

const Auth0Guard = ({ children }) => {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            loginWithRedirect();
        }
    }, [isLoading, isAuthenticated, loginWithRedirect]);

    if (isLoading) {
        return (
            <div className="auth-loading" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <p>Loading...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <div className="auth-loading" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <p>Redirecting to login...</p>
            </div>
        );
    }

    return <>{children}</>;
};

export default AuthGuard;
